module.exports = __webpack_public_path__ + "img/FR18106.c69c280e.png";